// extracted by mini-css-extract-plugin
export default {"contentWrapper":"PageLayout_contentWrapper__Uf18k"};